export default __webpack_public_path__ + "static/media/MO-CF-License-thru-6.1.2021.31d7e02a.pdf";